// extracted by mini-css-extract-plugin
export default {"root":"SellerFAQ_root__1cK9k"};